import * as yup from 'yup';

export const CreatePlanSubjectFormValidationAux = yup.object().shape({
    idPlan: yup.string().optional().nullable(), // Campo opcional
    idScientificArea: yup.string().required('O ID da área é obrigatório'),
    idSubject: yup.string().required('O ID da disciplina é obrigatório'),
    isCore: yup.boolean().required('O campo "é núcleo" é obrigatório'),
    hasExam: yup.boolean().required('O campo "Tem exame" é obrigatório'),
    semester: yup.number().typeError('O semestre deve ser um número')
        .required('O semestre é obrigatório')
        .positive('O semestre deve ser maior que zero'),
    level: yup.number().required('O nível do curso é obrigatório'),
    credits: yup.number().typeError("Numerico").required(),
});

export const CreatePlanSubjectFormValidation = yup.object().shape({
    idFaculty: yup.string().required('Unidade orgânica é obrigatória'),
    idDepartament: yup.string().required('Departamento é obrigatório'),
    idCourse: yup.string().required('Curso é obrigatório'),
    idPlan: yup.string().required('Plano de Curso é obrigatório'),
    planSubjects: yup.array().of(CreatePlanSubjectFormValidationAux).required('At least one subject is required'),
});